import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import NewsletterService from "../../utils/newsletterService";

export default function Footer() {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const timeoutRef = useRef(null);

    // Helper function to set status with auto-clear
    const setStatusWithTimeout = (message, timeout = 4000) => {
        setStatus(message);

        // Clear any existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        if (timeout > 0) {
            timeoutRef.current = setTimeout(() => setStatus(""), timeout);
        }
    };

    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setStatus("");
        setIsSubmitting(true);

        try {
            // Basic validation
            if (!email.trim()) {
                setStatusWithTimeout("❌ Please enter your email address.", 3000);
                setIsSubmitting(false);
                return;
            }

            if (!NewsletterService.validateEmail(email)) {
                setStatusWithTimeout("❌ Please enter a valid email address.", 3000);
                setIsSubmitting(false);
                return;
            }

            // Subscribe using service
            const result = await NewsletterService.subscribe(email);

            if (result.success) {
                setStatusWithTimeout("✅ Successfully subscribed to newsletter!", 5000);
                setEmail(""); // Clear the input
            } else {
                setStatusWithTimeout("❌ Failed to subscribe. Please try again.", 3000);
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);

            const errorInfo = NewsletterService.formatErrorMessage(error);
            const timeout = errorInfo.type === 'info' ? 4000 : 3000;
            setStatusWithTimeout(errorInfo.message, timeout);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <footer>
            <div className="container">
                <div className={styles.footerContainer}>
                    <div className={styles.footerCol}>
                        <h3>CloTech AI</h3>
                        <p>Innovating the future with custom technology solutions.</p>
                        <div className={styles.socialIcons}>
                            <Link style={{ textDecoration: "none" }} to="https://www.facebook.com/clotechai"><i className="fab fa-facebook-f"></i></Link>
                            <Link style={{ textDecoration: "none" }} to="https://x.com/clotechai"><i className="fa-brands fa-x"></i></Link>
                            <Link style={{ textDecoration: "none" }} to="http://linkedin.com/company/clotechai"><i className="fab fa-linkedin-in"></i></Link>
                            <Link style={{ textDecoration: "none" }} to="https://www.instagram.com/clotechai"><i className="fab fa-instagram"></i></Link>
                        </div>
                    </div>

                    <div className={styles.footerCol}>
                        <h3>Quick Links</h3>
                        <ul>
                            <li><Link to="">Home</Link></li>
                            <li><Link to="/about">About Us</Link></li>
                            <li><Link to="/services">Services</Link></li>
                            <li><Link to="/plans">Plans</Link></li>
                            <li><Link to="/careers">Careers</Link></li>
                            <li><Link to="/investor-relation">Investor Relation</Link></li>
                            <li><Link to="/partner">Partner</Link></li>
                        </ul>
                    </div>

                    <div className={styles.footerCol}>
                        <h3>Legal</h3>
                        <ul>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/terms-and-conditions">Terms and Conditions</Link></li>
                            <li><Link to="/service-delivery-policy">Service Delivery Policy</Link></li>
                            <li><Link to="/cancellation-refund-policy">Cancellation and Refund</Link></li>
                            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
                        </ul>
                    </div>

                    <div className={styles.footerCol}>
                        <h3>Support</h3>
                        <ul>
                            <li><Link to="/contact">Contact Us</Link></li>
                            <li><Link to="/faq">FAQs</Link></li>
                            <li><Link to="/sitemap">Sitemap</Link></li>
                        </ul>
                    </div>

                    <div className={styles.footerCol}>
                        <h3>Subscribe</h3>
                        <p>Subscribe to our newsletter for updates</p>
                        <form className={styles.subscribeForm} onSubmit={handleNewsletterSubmit}>
                            <input
                                type="email"
                                placeholder="Your Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isSubmitting}
                                required
                            />
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                style={{ opacity: isSubmitting ? 0.6 : 1 }}
                            >
                                {isSubmitting ? (
                                    <i className="fas fa-spinner fa-spin"></i>
                                ) : (
                                    <i className="fas fa-paper-plane"></i>
                                )}
                            </button>
                        </form>
                        {status && (
                            <div
                                style={{
                                    marginTop: '10px',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    fontSize: '13px',
                                    backgroundColor: status.includes('✅') ? 'rgba(40, 167, 69, 0.1)' :
                                        status.includes('ℹ️') ? 'rgba(23, 162, 184, 0.1)' :
                                            'rgba(220, 53, 69, 0.1)',
                                    color: status.includes('✅') ? '#28a745' :
                                        status.includes('ℹ️') ? '#17a2b8' :
                                            '#dc3545',
                                    border: `1px solid ${status.includes('✅') ? '#28a745' :
                                        status.includes('ℹ️') ? '#17a2b8' :
                                            '#dc3545'}`
                                }}
                            >
                                {status}
                            </div>
                        )}
                    </div>



                </div>

                <div className={styles.footerBottom}>
                    <p>&copy; 2026 CloTech AI Private Limited. All Rights Reserved.</p>
                </div>
            </div>
        </footer>
    );
}